/*
By Osvaldas Valutis, www.osvaldas.info
Available for use under the MIT License
*/

if (!('onCSSTransitionEnd' in $.fn)) {
	
	(function($, window, document, undefined) {
		
		if (typeof $.fn.onCSSTransitionEnd === 'function')	return;
		
		var s					=	document.body || document.documentElement, s = s.style, prefixAnimation = '', prefixTransition = '', eventAnimation = 'animationend', eventTransition = 'transitionend',
			transEndEventNames	=	{
				'WebkitTransition' : 'webkitTransitionEnd',
				'MozTransition'    : 'transitionend',
				'transition'       : 'transitionend' 
			},
			transEndEventName	=	transEndEventNames[ 'transition' ],
			transCSS			=	'transition';
		
		$.fn.extend({
			onCSSAnimationEnd: function(callback) {
				
				var $this	=	$( this );
				
				$this.one( eventAnimation, callback);
				
				if( ( prefixAnimation == '' && !( 'animation' in s ) ) || $this.css( prefixAnimation + 'animation-duration' ) == '0s' ) $.each($this, callback);
				
				return this;
				
			},
			onCSSTransitionEnd: function(callback) {
				
				var $this = $( this );
				if (typeof transEndEventName !== 'string' || ($this.css( transCSS + '-duration' ) === '0s' && $this.css( transCSS + '-delay' ) === '0s') ) {
					
					$.each($this, callback);
					
				} else {
					
					$this.one( eventTransition, callback );
					
				}
				
				return this;
				
			}
		});
	})(jQuery, window, document);

}





//add global easing method
jQuery.easing['jswing'] = jQuery.easing['swing'];
jQuery.extend( jQuery.easing,
{
	easeInCubic: function (x, t, b, c, d) {
		return c*(t/=d)*t*t + b;
	},
	easeOutCubic: function (x, t, b, c, d) {
		return c*((t=t/d-1)*t*t + 1) + b;
	},
	easeInOutCubic: function (x, t, b, c, d) {
		if ((t/=d/2) < 1) return c/2*t*t*t + b;
		return c/2*((t-=2)*t*t + 2) + b;
	}
});






/*!
 * Copyright (C) 2015-2024, Peppermill Inc.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are not permitted.
 *//*
 * PepValidate 3.1.1
 *
 *		2016-08-29 (3.0.0)
 *			- Setup callback system where callbacks can be registered in other scripts. This allows CSP headers to be setup and removes the need for eval().
 *
 *		2016-08-30 (3.0.1)
 *			- Error messages now scale into and out of view.
 *
 *		2016-09-08 (3.0.2)
 *			- Fixed custom minDate initialization for Air Datepicker.
 *			- Added support for maxDate for Air Datepicker.
 *			- Added support for onHide callbacks in Air Datepicker.
 *				- Must be registered via window.pepvalidateRegisterCallback().
 *
 *		2016-09-08 (3.0.3)
 *			- Added support for onSelect callbacks in Air Datepicker. Works the same way as onHide.
 *
 *		2016-11-29 (3.0.4)
 *			- Now handles checkbox and radio clicks to change the CSS state for the input.
 *
 *		2016-12-06 (3.0.5)
 *			- Checkbox/radio elements no longer get the "filled" class.
 *			- Updated checking optional content-block steps with checkboxes and radio inputs.
 *
 *		2017-01-09 (3.0.6)
 *			- Disabled the check to see if an element is hidden before initializing it.
 *
 *		2017-01-23 (3.0.7)
 *			- Datepickers are now shown inline if the current device is touch enabled.
 *
 *		2017-01-23 (3.0.8)
 *			- Now uses reCaptcha V3 if possible.
 *
 *		2020-12-15 (3.0.9)
 *			- Added URL stripping to regularExpressions.
 *
 *		2020-12-29 (3.0.10)
 *			- <select /> elements are no longer sanitized.
 *
 *		2022-07-26 (3.0.11)
 *			- PepValidate now executes immediately rather than waiting for document.ready.
 *
 *		2023-08-17 (3.1.0)
 *			- PepValidate now supports file uploads on forms with multipart/form-data enctype attribute.
 *
 *		2024-06-06 (3.1.1) (zsahs)
 *			- Checkboxes with required class that are left unchecked will prevent form from submitting.
 */
(function ($) {
	
	var regularExpressions		=	{
			ccn: /\b(?:\d[ -]*?){9,12}((?:\d[ -]*?){4})\b/,	//one matched set for last 4 digits
			ssn: /\b\d{3}-\d{2}-(\d{4})\b/,					//one matched set for last 4 digits
			url: /((http|ftp|https):\/\/)?([\w_-]+(?:(?:\.[\w_-]+)+))([\w.,@?^=%&:/~+#-]*[\w@?^=%&/~+#-])?/
		},
		pepvalidateCallbacks	=	{};
	
	/**
	 *	Takes in a single replacement parameter and masks the match to only show that single parameter. Used for Credit Card Numbers and Social Security Numbers.
	 *
	 *	@param	match	string	The matched string.
	 *	@param	p1		string	The matched replacement parameter.
	 *	@param	offset	integer	The offset in the search string where the `match` string is found.
	 *	@param	string	string	The search string.
	 *
	 *	@return			string	The masked string.
	 */
	function maskSingleReplacement(match, p1, offset, string) {
		
		var numOfDigits	=	match.replace(/[ -]/gi, '').length,
			output		=	'';

		for (var i = 0; i < numOfDigits - p1.length; i++) {
			
			if (i > 0 && i % p1.length === 0)	output	+=	'-';
			
			output	+=	'*';
			
		}
		
		return output + '-' + p1.replace(/[ ]/gi, '-');
		
	}
	
	/**
	 *	Searches a given string for sensitive information and masks that information. Currently supports Credit Card Numbers and Social Security Numbers.
	 *
	 *	@param	inputNode	DOMNode	The input node to sanitize of sensitive information.
	 *
	 *	@return				string	The sanitized string.
	 */
	function maskSensitiveInformation(inputNode) {
		if ('object' !== typeof inputNode || !('value' in inputNode)) return '';
		let output = inputNode.value;
		//NOTE: url redaction disabled as it's done on the back end now
		/*if (false === inputNode.classList.contains('email')) {
			output = output.replace(regularExpressions.url, '[url blocked]');
		}*/
		return output
				.replace(regularExpressions.ccn, maskSingleReplacement)
				.replace(regularExpressions.ssn, maskSingleReplacement);
	}

  /**
   * Checks if the input is blank depending on type attribute.
   * @returns {boolean} True if the input is blank, false otherwise.
   */
  function isInputBlank() {
    return (this.type !== 'checkbox' && this.type !== 'radio' && this.value === '')
      || (this.type === 'checkbox' && !this.checked)
      || (this.type === 'radio' && !this.checked);
  }

	/**
	 *	Validates inputs conditionally required based on the value of another input. Exclusive.
	 *
	 *	@param	displayErrorMsg	boolean	Whether or not to display the error message.
	 *	@param	onlyRemoeError	boolean	Whether or not to only remove the error, not add it.
	 *
	 *	@return	N/A
	 */
	function checkRequiredJoint(displayErrorMsg, onlyRemoveError) {
		
		if (typeof displayErrorMsg !== 'boolean') {
			
			var displayErrorMsg	=	false;
			
		}
		
		if (typeof onlyRemoveError !== 'boolean') {
			
			var onlyRemoveError	=	false;
			
		}
		
		//check if the joint fieldset exists
		if ($('#' + $(this).data('joint')).length) {
			
			//check that this isn't already valid
			if ($(this).closest('p').find('input, select, textarea').filter(isInputBlank).length) {
				
				//check if the other fieldset is valid
				if ($('#' + $(this).data('joint')).closest('p').find('input, select, textarea').filter(isInputBlank).length) {
					
					//both are invalid
					if (!onlyRemoveError) {
						
						$(this).closest('p, fieldset').addClass('error').removeClass('validated');
						$('#' + $(this).data('joint')).closest('p, fieldset').addClass('error').removeClass('validated');
						
					} else {
						
						$(this).closest('p, fieldset').removeClass('validated');
						$('#' + $(this).data('joint')).closest('p, fieldset').removeClass('validated');
						
					}
					
				} else {
					
					$(this).closest('p, fieldset').removeClass('error validated');
					$('#' + $(this).data('joint')).closest('p, fieldset').removeClass('error').addClass('validated');
					
				}
				
			} else {
				
				$(this).closest('p, fieldset').removeClass('error').addClass('validated');
				$('#' + $(this).data('joint')).closest('p, fieldset').removeClass('error validated');
				
			}
			
		}
		
	}

	/**
	 *	Validates required inputs.
	 *
	 *	@param	displayErrorMsg	boolean	Whether or not to display the error message.
	 *
	 *	@return	N/A
	 */
	function checkRequiredInput(displayErrorMsg) {
		
		if (typeof displayErrorMsg !== 'boolean') {
			
			var displayErrorMsg	=	false;
			
		}
		
		var $ele	=	$(this);
		
		if ((typeof this.type === 'string' && (this.type.toLowerCase() === 'text' || this.type.toLowerCase() === 'date' || this.type.toLowerCase() === 'tel' || this.type.toLowerCase() === 'email' || this.type.toLowerCase() === 'number' || this.type.toLowerCase() === 'password' || this.type.toLowerCase() === 'checkbox')) || $ele.is('select, textarea')) {
			
			var error	=	false;

			if ($ele.hasClass('required') && isInputBlank.call(this))
			{
				
				error	=	true;
				
			} else if ($ele.data('regex') && new RegExp($ele.data('regex'), 'gi').test(this.value) === false && (this.value !== '' || $ele.hasClass('required'))) {
				
				error	=	true;
				
			} else if ($ele.data('min-length') && parseInt($ele.data('min-length'), 10) > this.value.length && (this.value !== '' || $ele.hasClass('required'))) {
				
				error	=	true;
				
			} else if ($ele.data('max-length') && parseInt($ele.data('max-length'), 10) < this.value.length && (this.value !== '' || $ele.hasClass('required'))) {
				
				error	=	true;
				
			}
			
			if (error) {
				
				$ele.closest('p').data('hasError', true);
				
				if (displayErrorMsg) {
					
					if ($ele.closest('p').find('.error-msg').length) {
						
						$ele
							.closest('p')
								.find('.error-msg')
									.onCSSAnimationEnd(function () {
										
										$ele
											.closest('p')
												.removeClass('bounce');
										
									})
								.end()
								.addClass('bounce');
						
					} else {
						
						var errorMsg							=	'This field is required';
						if ($ele.data('error-msg'))	errorMsg	=	$ele.data('error-msg');
						
						$ele
							.closest('p')
								.removeClass('error')
								.append('<span class="error-msg"><span class="icon material-icons">report</span><span class="text">' + errorMsg +  '</span></span>');
						
					}
					
				}
				
				//find all the inputs before this one that have errors
				var currPIndex	=	$ele.closest('form').find('p').index($ele.closest('p')),
					errorCount	=	$ele.closest('form').find('p').filter(function (index) {
						
						return (currPIndex > index && $(this).data('hasError') === true);
						
					}).length;
				
				setTimeout(function () {
					
					$ele
						.closest('p')
							.addClass('error')
							.removeClass('validated');
					
				}, 50 + 100 * errorCount);
				
			} else {

				$ele.closest('p').data('hasError', false).removeClass('error');
				
				if (this.value !== '' || $ele.hasClass('required')) {
					
					$ele.closest('p').addClass('validated');
					
				}
					
			}
			
			if ($ele.closest('form').hasClass('show-steps')) {
				
				//check if all the elements in this .content-block have passed
				var errorCount	=	$ele.closest('.content-block').find('p').filter(function (index) {
						
						var $required	=	$(this).find('.required');
						
						return $(this).data('hasError') === true || ($required.length > 0 && !$(this).hasClass('validated'));
						
					}).length;
				
				if (errorCount === 0) {
					
					$ele
						.closest('.content-block')
							.prev('.content-step')
								.addClass('step-complete');
					
				} else {
					
					$ele
						.closest('.content-block')
							.prev('.content-step')
								.removeClass('step-complete')
									.closest('form')
										.removeClass('all-steps-complete');
					
				}
				
				//check if all steps are complete
				window.pepvalidateCheckFormComplete($ele.closest('form'));
				
			}
			
		}
		
	}
	
	/**
	 *	Initializes the datepicker elements passed-in.
	 *
	 *	@param	$elements	jQuery Object	The elements to initialize.
	 *
	 *	@return	N/A
	 */
	function initializeDatepickerElements($elements) {
		
		var isTouch	=	(typeof Modernizr === 'object' && typeof Modernizr.touchevents === 'boolean' && Modernizr.touchevents);
		
		$.each($elements, function (i) {
			
			var minDate		=	$elements.eq(i).data('mindate')		||	'',
				maxDate		=	$elements.eq(i).data('maxdate')		||	'',
				dateFormat	=	$elements.eq(i).data('dateformat')	||	'',
				onHide		=	$elements.eq(i).data('onhide')		||	'',
				onSelect	=	$elements.eq(i).data('onselect')	||	'';
			
			if (isTouch && $elements.eq(i).hasClass('ignore-mobile')) {
				
				$elements
					.eq(i)
						.attr('data-inline', 'true')
						.closest('p')
							.addClass('inline-datepicker');
				
			}
			
			/*if (isTouch && $elements.eq(i).hasClass('ignore-mobile')) {
				
				//use native datepicker
				
				if (minDate !== '') {
					
					var now		=	(minDate === 'today')
										?	new Date()
										:	new Date(minDate);
					if (!isNaN(now.getTime())) {
						
						var	day		=	(now.getDate() < 10)
											?	'0' + now.getDate()	
											:	now.getDate(),
							month	=	((now.getMonth() + 1) < 10)
											?	'0' + (now.getMonth() + 1)	
											:	(now.getMonth() + 1),
							date	=	  now.getFullYear() + '-' + month+ '-' + day;
						
						$elements
							.eq(i)
								.attr('min', date)
								.prop('min', date);
						
					}
					
				}
				
				if (typeof onHide === 'string' && onHide !== '' && onHide in pepvalidateCallbacks) {
					
					$elements
						.eq(i)
							.on('change', function () {
								
								var inst	=	{
										$el	:	$(this)
									};
								
								pepvalidateCallbacks[onHide].call(inst, true);
								
							});
					
				}
				
				if (typeof onSelect === 'string' && onSelect !== '' && onSelect in pepvalidateCallbacks) {
					
					$elements
						.eq(i)
							.on('change', function () {
								
								var inst	=	{
										$el	:	$(this)
									};
								
								pepvalidateCallbacks[onSelect].call('', new Date(), inst);
								
							});
					
				}
				
				$elements
					.eq(i)
						.attr('type', 'date')
						.prop('type', 'date');
				
			} else {*/
				
				//use datepicker.js
				var options	=	{
						language	:	'en',
						autoClose	:	true,
						onHide		:	function () {},
						onSelect	:	function () {}
					};
				
				if (dateFormat !== '')	options.dateFormat	=	dateFormat;
				
				if (minDate === 'today') {
					
					options.minDate	=	new Date();
					
				} else if	(minDate !== '') {
					
					minDate	=	new Date(minDate);
					
					if (!isNaN(minDate.getTime())) {
						
						options.minDate	=	minDate;
						
					}
					
				}
				
				if (maxDate === 'today') {
					
					options.maxDate	=	new Date();
					
				} else if (maxDate !== '') {
					
					maxDate	=	new Date(maxDate);
					
					if (!isNaN(maxDate.getTime())) {
						
						options.maxDate	=	maxDate;
						
					}
					
				}
				
				if (typeof onHide === 'string' && onHide !== '' && onHide in pepvalidateCallbacks) {
					
					options.onHide	=	pepvalidateCallbacks[onHide];
					
				}
				
				if (typeof onSelect === 'string' && onSelect !== '' && onSelect in pepvalidateCallbacks) {
					
					options.onSelect	=	pepvalidateCallbacks[onSelect];
					
				}
				
				$elements.eq(i).datepicker(options);
				
			//}
			
		});
		
	}
	
	function checkOptionalStepComplete($contentBlock) {
		
		//check if all the fields are filled-out in this content block
		var $blank	=	$contentBlock.find('input, textarea, select').filter(function () {
				
				if (typeof this.type === 'string' && (this.type === 'checkbox' || this.type === 'radio')) {
					
					return !this.checked;
					
				} else {
					
					return $(this).val() === '';
					
				}
				
			});
		
		if ($blank.length === 0) {
			
			$contentBlock
				.prev('.content-step')
					.addClass('step-complete');
			
		} else {
			
			$contentBlock
				.prev('.content-step')
					.removeClass('step-complete');
			
		}
		
	}
	
	window.pepvalidateRegisterCallback	=	function (action, callback) {

		if (typeof action !== 'string' || action.length === 0)	return false;
		if (typeof callback !== 'function')						return false;
		
		pepvalidateCallbacks[action]	=	callback;
		
		return true;
		
	};
	
	window.pepvalidateCheckFormComplete	=	function ($form) {
		
		if ($form.hasClass('show-steps')) {
			
			var $steps	=	$form.find('.content-step').filter(function () {
					
					return ($(this).data('step') !== 'done' && $(this).data('step') !== 'clear' && !$(this).hasClass('optional'));
					
				});
			
			if ($steps.length === $steps.filter('.step-complete').length) {
				
				$form
					.addClass('all-steps-complete')
					.find('.content-step[data-step=done], .content-step[data-step=clear]')
						.addClass('step-complete');
				
			} else {
				
				$form
					.removeClass('all-steps-complete')
					.find('.content-step[data-step=done], .content-step[data-step=clear]')
						.removeClass('step-complete');
				
			}
			
		}
		
	};

	/**
	 *	Destroys a setup pepvalidate form.
	 *
	 *	@return N/A
	 */
	window.pepvalidateDestroyForm	=	function () {
		
		var $form			=	$(this),
			$formElements	=	$form.find('input[type=text], input[type=date], input[type=tel], input[type=email], input[type=number], input[type=password], select, textarea').filter(function () { return $(this).css('display') !== 'none'; });
		
		$formElements.off('focus.pepvalidate3 blur.pepvalidate3 keyup.pepvalidate3 change.pepvalidate3 paste.pepvalidate3 sanitize.pepvalidate3');
		
		$form.off('click.pepvalidate3', '.error-msg');
		
		$form.find('.note').find('.handle').off('click.pepvalidate3');
		
		$form.find('.submit-wrapper').off('click.pepvalidate3');
		
		$form.off('click.pepvalidate3', '.overlay .close').off('click.pepvalidate3', '.overlay');
		
		$form.off('click.pepvalidate3');
		
		$form.off('submit.pepvalidate3');
		
	};

	/**
	 *	Setup a pepvalidate form.
	 *
	 *	@return N/A
	 */
	window.pepvalidateInitForm	=	function () {
		
		var $form				=	$(this),
			$formElements		=	$form.find('input[type=text], input[type=date], input[type=tel], input[type=email], input[type=number], input[type=password], input[type=checkbox], input[type=radio], select, textarea'),//.filter(function () { return $(this).is(':visible'); }),
			$datepickerElements	=	$formElements.filter('.date');
		
		//setup input interaction
		$formElements.on('focus.pepvalidate3', function () {
			
			$(this).closest('p').addClass('active');
			
		}).on('blur.pepvalidate3', function () {
			
			var $input	=	$(this);
			
			if ($input.hasClass('required')) {
				
				checkRequiredInput.call(this, false);
				
			} else if ($input.hasClass('required-joint')) {
				
				checkRequiredJoint.call($input[0], false, true);
				
			} else if ($input.closest('fieldset').hasClass('required-joint')) {
				
				checkRequiredJoint.call($input.closest('fieldset')[0], false, true);
				
			} else if (typeof $input.data('regex') === 'string') {
				
				checkRequiredInput.call(this, false);
				
			} else if ($input.closest('.content-block').prev('.content-step').hasClass('optional')) {
				
				checkOptionalStepComplete($input.closest('.content-block'));
				
			}
			
			if (!$input.closest('p').hasClass('checkbox') && !$input.closest('p').hasClass('radio')) {
				
				if ($input.val() === '') {
					
					$input
						.closest('p')
							.removeClass('active filled');
					
				} else {
					
					//check for sensitive information and mask it if found
					$input
						.trigger('sanitize.pepvalidate3')
							.closest('p')
								.addClass('filled');
					
				}
				
			}
			
		}).on('keyup.pepvalidate3, change.pepvalidate3, paste.pepvalidate3', function () {
			
			var $input	=	$(this);
			
			if ($input.hasClass('required')) {
				
				checkRequiredInput.call(this, false);
				
			} else if ($input.hasClass('required-joint')) {
				
				checkRequiredJoint.call($input[0], false, true);
				
			} else if ($input.closest('fieldset').hasClass('required-joint')) {
				
				checkRequiredJoint.call($input.closest('fieldset')[0], false, true);
				
			} else if (typeof $input.data('regex') === 'string') {
				
				checkRequiredInput.call(this, false);
				
			} else if ($input.closest('.content-block').prev('.content-step').hasClass('optional')) {
				
				checkOptionalStepComplete($input.closest('.content-block'));
				
			}
			
			if (!$input.closest('p').hasClass('checkbox') && !$input.closest('p').hasClass('radio')) {
				
				if ($input.val() === '') {
					
					$input
						.closest('p')
							.removeClass('filled');
					
				} else {
					
					//check for sensitive information and mask it if found
					$input
						.closest('p')
							.addClass('filled');
					
				}
				
			}
			
		}).on('sanitize.pepvalidate3', function () {
			
			//only sanitize if no class is set to bypass for this form element
			if (!$(this).hasClass('do-not-sanitize') && false === $(this).is('select'))	$(this).val(maskSensitiveInformation(this));
			
		}).each(function () {
			
			if (this.value !== '') {
				
				$(this)
					.trigger('change')
						.closest('p')
							.addClass('active');
				
			}
			
		});
		
		$form
			.find('input[type=checkbox], input[type=radio]')
				.on('change.pepvalidate3', function () {
					
					var $input	=	$(this);
					
					//check if this is a checkbox or a radio input
					if ($input.closest('p').hasClass('checkbox') || $input.closest('p').hasClass('radio')) {
						
						if ($input.prop('checked')) {
							
							$input
								.closest('p')
									.addClass('checked');
							
							if ($input.closest('p').hasClass('radio')) {
								
								$input
									.closest('form')
										.find('input[name="' + this.name + '"]')
											.not(this)
												.closest('p')
													.removeClass('checked');
								
							}
							
						} else {
							
							$input
								.closest('p')
									.removeClass('checked');
							
						}
						
					}
					
				})
				.trigger('change.pepvalidate3');
		
		
		
		
		
		//setup datepicker
		if ($datepickerElements.length) {
			
			//check if datepicker is already loaded
			if ($.fn.datepicker) {
				
				initializeDatepickerElements($datepickerElements);
				
			} else {
				
				//datepicker not loaded, load it now
				$.ajax({
					url			:	'/library/js/datepicker.js',
					dataType	:	'script',
					cache		:	true,
					success		:	function (data) {
						
						$.fn.datepicker.language['en'] = {
							days		:	['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
							daysShort	:	['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
							daysMin		:	['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
							months		:	['January','February','March','April','May','June', 'July','August','September','October','November','December'],
							monthsShort	:	['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
							today		:	'Today',
							clear		:	'Clear',
							dateFormat	:	'mm/dd/yyyy',
							timeFormat	:	'hh:ii aa',
							firstDay	:	0
						};
						
						initializeDatepickerElements($datepickerElements);
						
					}
				});
				
				$('body').append('<link href="https://www.peppermillreno.com/library/css/datepicker.min.css" rel="stylesheet" />')
				
			}
			
		}
		
		
		
		
		
		//setup error message interaction
		$form.on('click.pepvalidate3', '.error-msg', function () {
			
			$(this).onCSSTransitionEnd(function () { $(this).remove() }).closest('p').removeClass('error bounce').find('input, select, textarea').focus();
			
		});
		
		
		
		
		
		//setup help messages
		$form.find('.note').find('.handle').on('click.pepvalidate3', function (event) {
			
			event.preventDefault();
			
			if (typeof $(this).data('content') === 'string') {
				
				$($(this).data('content')).slideToggle(250, 'easeOutCubic');
				
			} else {
			
				$(this).closest('p').next('.note-content').slideToggle(250, 'easeOutCubic');
				
			}
			
		});
		
		
		
		
		
		//setup user interaction with loading spinner
		$form.find('.submit-wrapper').on('click.pepvalidate3', function () {
			
			if ($form.hasClass('loading')) {
				
				$(this).onCSSAnimationEnd(function () { $(this).removeClass('bounce') }).addClass('bounce');
				
			}
			
		});
		
		
		
		
		
		//setup overlay interaction
		$form.on('click.pepvalidate3', '.overlay .close', function (event) {
			
			event.preventDefault();
			
			$form.find('.overlay').onCSSTransitionEnd(function () { $(this).remove(); }).end().removeClass('overlay-active').css({ minHeight : '' });
			
		}).on('click.pepvalidate3', '.overlay', function (event) {
			
			event.stopPropagation();
			
		});
		
		$form.on('click.pepvalidate3', function () {
			
			$form.find('.overlay').find('.close').trigger('click.pepvalidate3');
			
		});
		
		
		
		
		
		//setup step completion callbacks
		$form
			.find('.content-step')
				.each(function () {
					
					if (typeof $(this).data('step-callback') === 'string' && $(this).data('step-callback') in pepvalidateCallbacks) {
						
						pepvalidateCallbacks[$(this).data('step-callback')].apply(this);
						
					}
					
				});
		
		
		
		
		
		//long poll the inputs looking for auto-fill data
		var autoPollTimer	=	setInterval(function () {
			
			var $activeFormElements	=	$formElements.filter(function () { return $(this).val() !== ''; });
				
				//only run this long poll if there are still blank form elements
				if ($formElements.length === $activeFormElements.length) {
					
					clearInterval(autoPollTimer);
					
				}
				
				$activeFormElements.closest('p').addClass('active');
				
			}, 1000);
		
		
		
		
		
		//setup submit handler
		$form.on('submit.pepvalidate3', function (event) {
			
			const ajaxCallback	=	function () {

        const ajaxEncType = $form.attr('enctype') || '';
        const ajaxOptions = {
          url: $form.attr('action') || '',
          type: $form.attr('method') || 'post',
          dataType	:	'json',
          data: $form.serialize(),
          success		:	function (response) {
            if (typeof response.STATUS !== 'string') {
              response.STATUS	=	'';
            }

            if (typeof response.MSG !== 'string') {
              response.MSG	=	'';
            }

            if (typeof response.SCRIPT !== 'object') {
              response.SCRIPT	=	[];
            }

            if (typeof response.DATA !== 'object') {
              response.DATA	=	[];
            }

            if (response.STATUS === 'SUCCESS' && !$form.find('.submit-wrapper').hasClass('keep-submit-btn')) {
              $form.find('.submit-wrapper').slideUp(250, 'easeOutCubic');
            }

            if (response.MSG !== '') {
              //determine the height of the MSG
              const $testEle	=	$('<div />').css({ position : 'absolute', left : '-2000px', width : $form.width() }).html(response.MSG).appendTo('body');

              requestAnimationFrame(function () {
                $form.css({ minHeight : $testEle.height() }).removeClass('loading').append('<div class="overlay">' + response.MSG + '<a class="close" href="#">X</a></div>');
                $testEle.remove();

                requestAnimationFrame(function () {
                  $form.addClass('overlay-active');
                });
              });
            }

            if (response.SCRIPT.length > 0) {
              //run callback if it exists
              if (response.SCRIPT[0] in pepvalidateCallbacks) {
                //`this` refers to the form submitted
                pepvalidateCallbacks[response.SCRIPT[0]].apply($form[0], response.SCRIPT.slice(1));
              }
            }

            //log this submission with Google Analytics
            var formName = $form.attr('data-track-name');
            if (typeof window.pepTracking !== 'undefined' && typeof formName !== 'undefined') {
              window.pepTracking.event("Webform", formName, 'Submit Triggered', 0, false);
            }
          },
          error		:	function (a, b, c) {
            $form.removeClass('loading').append('<div class="overlay">An Error Occured<a class="close" href="#">X</a></div>');

            requestAnimationFrame(function () {
              $form.addClass('overlay-active');
            });

            if (typeof console === 'object' && typeof console.log !== 'undefined') {
              console.log(a);
              console.log(b);
              console.log(c);
            }
          }
        };

        if ('multipart/form-data' === ajaxEncType) {
          ajaxOptions.data = new FormData($form[0]);
          ajaxOptions.dataType = 'json';
          ajaxOptions.contentType = false;
          ajaxOptions.cache = false;
          ajaxOptions.processData = false;
        }

				$.ajax(ajaxOptions);
			};
			
			if ($form.hasClass('loading')) {
				
				$form.find('.submit-wrapper').onCSSAnimationEnd(function () { $(this).removeClass('bounce') }).addClass('bounce');
				
				event.preventDefault();
				
				return;
				
			}
			
			$form.find('input, select, textarea').trigger('sanitize.pepvalidate3');
			
			$.each($form.find('input, select, textarea').filter(function () {
				
				return $(this).hasClass('required') || typeof $(this).data('regex') === 'string';
				
			}), function () {
				
				checkRequiredInput.call(this, true);
				
			});
			
			$.each($form.find('.required-joint'), function () {
				
				checkRequiredJoint.call(this, true, false);
				
			});
			
			var $errors	=	$form.find('p').filter(function () {
					
					return $(this).data('hasError') === true;
					
				});
			
			if ($errors.length) {
				
				$errors.find('input, select, textarea').eq(0).focus();
				
				event.preventDefault();
				
			} else {
				
				//submit form
				$form.addClass('loading');
				
				if (!$form.hasClass('ajax-ignore')) {
					
					event.preventDefault();
					
					//run reCaptcha if possible
					if ('grecaptcha' in window) {
						
						grecaptcha.execute('6LfAcbAUAAAAAMqDp1N977WgJ5pbTFPxwpFA2TaK', {action: 'form_submission'}).then(function(token) {
							
							$form
								.append('<input name="g-recaptcha-response" type="hidden" value="' + token + '" />');
							
							ajaxCallback.call(this);
							
						});
						
					} else {
						
						ajaxCallback.call(this);
						
					}
					
				}
				
			}
			
		});
		
	}
	
	$.each($('.pepvalidate-v3').filter('.auto-init'), window.pepvalidateInitForm);
	
})(jQuery);